import { size } from "@evg-ui/lib/constants/tokens";

export const navbarHeight = size.xl;
export const subheaderHeight = "48px";
